import React from "react";
import Box from "@material-ui/core/Box";
import Copyright from "./Copyright";

export default function Footer() {
  return (
    <Box mt={5}>
      <Copyright />
    </Box>
  );
}
